import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { useBreakpoints } from '@fiverr-private/hooks';
import { Container } from '@fiverr-private/layout_components';
import { Fade, Collapse } from '@fiverr-private/transition';

import * as SearchSelector from '../../../selectors/Search';
import * as SuggestionsSelector from '../../../selectors/Suggestions';
import { aiPillPanelClass } from '../styles.ve.css';
import AiPillEmptyState from './AiPillEmptyState';
import AiPillTypingState from './AiPillTypingState';

const AiPillSearchPanel = ({ className, search, historyIds, popularIds, gigIds, show }) => {
    const breakpoints = useBreakpoints();
    const isMobile = breakpoints.default && !breakpoints.md;
    const isEmpty = search ? !historyIds.length && !gigIds.length : !historyIds.length && !popularIds.length;

    if (isEmpty) {
        return null;
    }

    const panel = (
        <Container className={classNames(className, 'ai-pill-search-panel', aiPillPanelClass)} tabIndex={0}>
            <Fade key={search ? 1 : 2} duration="moderate1">
                <Container marginTop="0.5" paddingBottom="4" paddingX={{ default: '0', md: '2' }}>
                    {search ? (
                        <AiPillTypingState historyIds={historyIds} gigIds={gigIds} />
                    ) : (
                        <AiPillEmptyState historyIds={historyIds} popularIds={popularIds} />
                    )}
                </Container>
            </Fade>
        </Container>
    );

    // Collapse pins an inline pixel `height` + `overflow: hidden` on its child, which would defeat
    // the mobile fullscreen layout where the panel flex-fills the space above the field and scrolls.
    if (isMobile) {
        return panel;
    }

    return (
        <Collapse in={show} duration="moderate1">
            {panel}
        </Collapse>
    );
};

AiPillSearchPanel.propTypes = {
    className: PropTypes.string,
    search: PropTypes.string,
    historyIds: PropTypes.arrayOf(PropTypes.string),
    popularIds: PropTypes.arrayOf(PropTypes.string),
    gigIds: PropTypes.arrayOf(PropTypes.string),
};

AiPillSearchPanel.defaultProps = {
    className: '',
    search: '',
    historyIds: [],
    popularIds: [],
    gigIds: [],
};

export { AiPillSearchPanel };

const mapStateToProps = (state) => ({
    search: SearchSelector.search(state),
    historyIds: SuggestionsSelector.historySuggestionIds(state),
    popularIds: SuggestionsSelector.popularSuggestionIds(state),
    gigIds: SuggestionsSelector.gigSuggestionIds(state),
});

export default connect(mapStateToProps)(AiPillSearchPanel);
